import React from "react";
import { KnowledgeTab, sampleAgent } from "./index";
import { AgentLayout } from "./AgentLayout";

export const KnowledgePage: React.FC = () => {
  // In a real app, you would fetch the agent data based on agentId
  const agent = sampleAgent;

  return (
    <AgentLayout activeTab="knowledge">
      <KnowledgeTab agent={agent} />
    </AgentLayout>
  );
};
